/**
 * Telegram service provider
 */

export default {
    popupUrl: 'https://telegram.me/share/url?url={url}',
    popupWidth: 600,
    popupHeight: 500,
};



// WEBPACK FOOTER //
// ./source/services/telegram.js